const SVGSymbols = () => (
  <svg width="0" height="0" style="position:absolute">
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 27 14"
      id="icon-arrow-down"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M.61 2.983l11.727 9.72c.63.521 1.542.516 2.165-.014l11.253-9.565a1.684 1.684 0 00-2.18-2.565l-10.177 8.65L2.759.391A1.684 1.684 0 00.611 2.983z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 14 27"
      id="icon-arrow-left"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.104.61L.384 12.338a1.683 1.683 0 00.013 2.165l9.566 11.253a1.684 1.684 0 002.565-2.18l-8.65-10.177 8.818-10.639A1.684 1.684 0 0010.104.611z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 14 27"
      id="icon-arrow-right"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.983 25.735l9.72-11.726a1.683 1.683 0 00-.014-2.165L3.124.591a1.684 1.684 0 00-2.566 2.18L9.21 12.948.391 23.587a1.684 1.684 0 002.592 2.148z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 27 14"
      id="icon-arrow-up"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M25.735 10.104L14.01.384a1.683 1.683 0 00-2.165.013L.591 9.963a1.684 1.684 0 002.18 2.565l10.177-8.65 10.639 8.818a1.684 1.684 0 002.148-2.592z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 33 32"
      id="icon-back"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M.465 14.46l-.003.001a1.58 1.58 0 00-.34.509l-.002.005a1.572 1.572 0 000 1.206l.002.005c.024.057.052.115.084.17l.014.026.022.036.021.033.027.037.023.033.023.032.026.03.026.031.027.03.028.03.022.022L14.46 30.693a1.583 1.583 0 002.236-2.237L5.401 17.16h25.148a1.582 1.582 0 000-3.164H5.401L16.697 2.7A1.583 1.583 0 0014.461.462L.465 14.46z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 31 32"
      id="icon-close"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.208 15.593L.468 28.51a1.542 1.542 0 102.196 2.165l12.71-12.885 12.725 12.9a1.564 1.564 0 002.226-2.196L17.569 15.563 30.31 2.646A1.542 1.542 0 1028.113.48l-12.71 12.886L2.679.466A1.564 1.564 0 00.452 2.661l12.756 12.931z"></path>
    </symbol>
    <symbol
      viewBox="0 0 32 33"
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      id="icon-down"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.46 31.665v.002c.15.15.325.264.51.34l.005.002a1.572 1.572 0 001.206 0l.004-.001c.058-.025.115-.053.171-.084l.026-.015.035-.022.033-.02.038-.028.033-.023.032-.023.03-.026.03-.025.031-.027.03-.028.022-.022 13.997-13.996a1.583 1.583 0 00-2.237-2.236L17.16 26.727V1.58a1.582 1.582 0 00-3.164 0v25.148L2.7 15.432A1.583 1.583 0 00.462 17.67L14.46 31.665z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 22 31"
      id="icon-location"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.864 30.59l-.582-.712C9.894 29.36 0 17.785 0 10.865 0 4.851 4.915.001 10.864.001c5.95 0 10.865 4.914 10.865 10.864 0 6.92-9.895 18.56-10.283 19.013l-.582.711z"
        fill-rule="nonzero"
      ></path>
      <path
        d="M10.864 15.004c-2.263 0-4.139-1.876-4.139-4.139 0-2.263 1.876-4.139 4.14-4.139 2.263 0 4.138 1.876 4.138 4.139 0 2.263-1.875 4.139-4.139 4.139zm0-6.726a2.594 2.594 0 00-2.587 2.587 2.594 2.594 0 002.587 2.587 2.594 2.594 0 002.587-2.587 2.594 2.594 0 00-2.587-2.587z"
        fill-rule="nonzero"
      ></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 129 40"
      id="icon-logo"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.208 1.716v.451c-.52.023-.903.068-1.151.158-.271.113-.452.294-.542.542-.09.271-.135.677-.135 1.242v11.287c0 .52.045.904.112 1.152.09.248.249.429.497.497.271.09.61.135 1.084.135H7.54c.88 0 1.558-.158 2.077-.497.52-.316.903-.812 1.174-1.467.27-.655.474-1.513.587-2.529h.52a20.962 20.962 0 00-.069 1.897c0 .293 0 .745.023 1.31.023.586.068 1.196.135 1.805-.767-.022-1.625-.045-2.596-.068h-6.93c-.88.023-1.694.046-2.461.068v-.451c.52-.023.903-.09 1.151-.18a.753.753 0 00.497-.543c.09-.27.135-.677.135-1.219V4.11c0-.565-.045-.971-.135-1.242-.068-.248-.248-.429-.52-.542C.88 2.235.498 2.19 0 2.167v-.451c.339.022.79.022 1.332.045.564.022 1.151.022 1.783.022.565 0 1.13 0 1.693-.022.565-.023 1.039-.023 1.4-.045zM18.783 5.734c1.332 0 2.37.407 3.115 1.197.745.79 1.129 2.054 1.129 3.792h-7.789l-.045-.429h5.44a8.203 8.203 0 00-.18-2.031c-.135-.632-.338-1.13-.632-1.513-.293-.384-.655-.564-1.129-.564-.654 0-1.196.338-1.67 1.016-.474.7-.768 1.783-.88 3.296l.067.112c-.022.204-.022.452-.045.7-.023.249-.023.474-.023.723 0 1.038.158 1.919.474 2.619.317.7.723 1.241 1.242 1.602.52.339 1.039.52 1.558.52.61 0 1.196-.158 1.76-.452.565-.293 1.04-.858 1.446-1.67l.451.18a5.301 5.301 0 01-.835 1.513 4.477 4.477 0 01-1.445 1.219c-.587.293-1.264.451-2.054.451-1.061 0-1.965-.248-2.755-.722-.79-.474-1.377-1.152-1.806-2.032-.429-.88-.632-1.941-.632-3.16 0-1.332.226-2.484.655-3.432.429-.948 1.038-1.67 1.829-2.167.79-.52 1.715-.768 2.754-.768zM28.83 21.943c-.836 0-1.626-.09-2.326-.248-.722-.158-1.287-.429-1.716-.768-.429-.338-.655-.767-.655-1.286 0-.497.204-.926.633-1.31.429-.383 1.016-.654 1.783-.858l.158.362a1.614 1.614 0 00-.745.654 2.09 2.09 0 00-.248.994c0 .654.316 1.174.925 1.535.61.361 1.423.542 2.439.542.677 0 1.309-.09 1.941-.271a3.335 3.335 0 001.49-.836c.384-.383.564-.903.564-1.512 0-.474-.18-.88-.519-1.22-.339-.315-1.038-.473-2.054-.473h-1.58a7.54 7.54 0 01-1.468-.136 2.402 2.402 0 01-1.106-.519c-.271-.27-.406-.655-.406-1.129 0-.542.225-1.06.677-1.535.451-.474 1.219-.948 2.28-1.422l.27.203c-.428.248-.834.497-1.173.745-.339.248-.497.542-.497.903 0 .474.339.722 1.039.722h2.686c1.039 0 1.942.226 2.687.655.745.43 1.128 1.129 1.128 2.122 0 .7-.225 1.377-.7 1.987-.45.632-1.128 1.129-2.054 1.512-.925.384-2.077.587-3.454.587zm.135-9.052c-1.152 0-2.145-.294-2.935-.858-.79-.565-1.197-1.468-1.197-2.71 0-1.241.407-2.167 1.197-2.731.79-.564 1.783-.858 2.935-.858 1.174 0 2.144.294 2.934.858.79.564 1.197 1.49 1.197 2.732 0 1.241-.406 2.144-1.197 2.709-.79.564-1.76.858-2.934.858zm0-.407c.519 0 .925-.226 1.219-.677.293-.452.429-1.287.429-2.483 0-1.197-.136-2.032-.43-2.484-.293-.474-.7-.7-1.218-.7-.497 0-.903.226-1.197.7-.293.452-.451 1.287-.451 2.484 0 1.196.158 2.031.451 2.483.294.451.7.677 1.197.677zm3.34-4.853l-.406-.159a3.14 3.14 0 011.084-1.377c.52-.383 1.039-.587 1.603-.587.429 0 .745.113.993.362.249.225.384.541.384.97 0 .474-.135.79-.384.994-.248.203-.496.293-.767.293-.249 0-.474-.09-.678-.248-.203-.158-.316-.43-.338-.768-.023-.36.09-.812.338-1.377l.249.09c-.61.249-1.039.497-1.332.768-.271.248-.52.61-.745 1.039zM42.013 5.734c1.332 0 2.37.407 3.115 1.197.745.79 1.129 2.054 1.129 3.792h-7.789l-.045-.429h5.44a8.203 8.203 0 00-.18-2.031c-.135-.632-.338-1.13-.632-1.513-.293-.384-.655-.564-1.129-.564-.654 0-1.196.338-1.67 1.016-.474.7-.768 1.783-.88 3.296l.067.112c-.022.204-.022.452-.045.7-.023.249-.023.474-.023.723 0 1.038.158 1.919.474 2.619.317.7.723 1.241 1.242 1.602.52.339 1.039.52 1.558.52.61 0 1.196-.158 1.76-.452.565-.293 1.04-.858 1.446-1.67l.451.18a5.301 5.301 0 01-.835 1.513 4.477 4.477 0 01-1.445 1.219c-.587.293-1.264.451-2.054.451-1.061 0-1.965-.248-2.755-.722-.79-.474-1.377-1.152-1.806-2.032-.429-.88-.632-1.941-.632-3.16 0-1.332.226-2.484.655-3.432.429-.948 1.038-1.67 1.829-2.167.79-.52 1.715-.768 2.754-.768zM55.626 5.734c.61 0 1.084.09 1.49.249.384.158.7.36.948.632.271.293.452.654.565 1.106.113.451.18 1.06.18 1.828v6.05c0 .633.113 1.062.362 1.287.248.226.677.34 1.264.34v.473a27.897 27.897 0 00-1.197-.068c-.542-.022-1.083-.022-1.603-.022-.519 0-1.015 0-1.535.022-.496.023-.88.046-1.128.068v-.474c.519 0 .88-.113 1.083-.339.203-.225.316-.654.316-1.286V8.917a6.53 6.53 0 00-.113-1.196 1.546 1.546 0 00-.474-.858c-.248-.203-.61-.316-1.083-.316-.836 0-1.535.339-2.077 1.038-.52.7-.79 1.558-.79 2.574v5.44c0 .633.112 1.062.316 1.287.225.226.587.34 1.083.34v.473c-.248-.022-.61-.045-1.106-.068-.474-.022-.993-.022-1.512-.022-.52 0-1.039 0-1.603.022-.565.023-.971.046-1.242.068v-.474c.587 0 .993-.113 1.242-.339.248-.225.383-.654.383-1.286V8.51c0-.677-.112-1.174-.338-1.513-.226-.316-.655-.474-1.287-.474V6.05a14.88 14.88 0 002.822 0 9.286 9.286 0 001.242-.248v2.46c.383-.925.925-1.58 1.625-1.963a4.315 4.315 0 012.167-.565zM71.948 0v15.238c0 .678.113 1.174.339 1.49.248.34.677.497 1.287.497v.474a14.523 14.523 0 00-1.4-.068c-.52 0-.993.023-1.445.068a6.857 6.857 0 00-1.219.249V2.709c0-.677-.113-1.174-.361-1.512-.226-.317-.655-.475-1.264-.475V.248a14.88 14.88 0 002.822 0A9.286 9.286 0 0071.948 0zm-5.08 5.734c.656 0 1.265.136 1.807.43.564.293.948.767 1.174 1.444l-.271.248c-.203-.542-.52-.925-.926-1.174a2.577 2.577 0 00-1.377-.383c-.858 0-1.558.451-2.1 1.377-.541.903-.812 2.302-.79 4.199 0 1.241.113 2.28.317 3.07.203.79.519 1.355.925 1.738.43.384.926.565 1.513.565.587 0 1.106-.249 1.58-.745.474-.497.768-1.22.858-2.145l.203.474c-.158 1.016-.52 1.806-1.084 2.37-.564.542-1.332.813-2.302.813-.926 0-1.739-.226-2.438-.654-.7-.452-1.22-1.13-1.603-2.032-.384-.926-.565-2.077-.565-3.454 0-1.377.226-2.506.678-3.41.474-.925 1.083-1.602 1.85-2.054a4.958 4.958 0 012.552-.677zM80.233 5.734c1.332 0 2.37.407 3.115 1.197.745.79 1.129 2.054 1.129 3.792h-7.789l-.045-.429h5.44a8.203 8.203 0 00-.18-2.031c-.135-.632-.338-1.13-.632-1.513-.293-.384-.655-.564-1.129-.564-.654 0-1.196.338-1.67 1.016-.474.7-.768 1.783-.88 3.296l.067.112c-.022.204-.022.452-.045.7-.023.249-.023.474-.023.723 0 1.038.158 1.919.474 2.619.317.7.723 1.241 1.242 1.602.52.339 1.039.52 1.558.52.61 0 1.196-.158 1.76-.452.565-.293 1.04-.858 1.446-1.67l.451.18a5.301 5.301 0 01-.835 1.513 4.477 4.477 0 01-1.445 1.219c-.587.293-1.264.451-2.054.451-1.061 0-1.965-.248-2.755-.722-.79-.474-1.377-1.152-1.806-2.032-.429-.88-.632-1.941-.632-3.16 0-1.332.226-2.484.655-3.432.429-.948 1.038-1.67 1.829-2.167.79-.52 1.715-.768 2.754-.768zM47.215 39.683v-.452c.52-.023.905-.091 1.154-.181a.755.755 0 00.498-.544c.09-.271.136-.678.136-1.221V26.06c0-.565-.045-.973-.136-1.221-.068-.272-.249-.453-.52-.543-.25-.114-.634-.159-1.132-.181v-.453c.385.023.838.023 1.403.045.566.023 1.132.023 1.697.023.634 0 1.222 0 1.765-.023.543-.022.973-.022 1.313-.045v.453c-.498.022-.883.067-1.132.18a.832.832 0 00-.52.544c-.09.248-.136.656-.136 1.221v11.224c0 .543.045.95.136 1.221.09.272.271.453.52.544.25.09.634.158 1.132.18v.453c-.34-.023-.77-.045-1.313-.068H48.618c-.565.023-1.018.045-1.403.068zm-9.503 0v-.452c.52-.023.905-.091 1.154-.181a.755.755 0 00.498-.544c.09-.271.135-.678.135-1.221V26.06c0-.565-.045-.973-.135-1.221-.068-.272-.25-.453-.52-.543-.25-.114-.634-.159-1.132-.181v-.453c.34.023.792.023 1.335.045.566.023 1.154.023 1.787.023.566 0 1.132 0 1.675-.023.566-.022 1.018-.022 1.38-.045v.453c-.498.022-.882.067-1.131.18a.832.832 0 00-.52.544c-.091.248-.136.656-.136 1.221v11.224c0 .543.045.95.135 1.221.09.272.272.453.52.544.25.09.634.158 1.132.18v.453a62.863 62.863 0 00-1.38-.068H39.047c-.543.023-.996.045-1.335.068zm3.371-7.829v-.452h8.938v.452h-8.938zM60.136 27.69c1.018 0 1.9.204 2.693.634.792.43 1.403 1.086 1.878 1.991.475.905.701 2.082.701 3.553 0 1.47-.226 2.647-.701 3.552-.475.883-1.086 1.539-1.878 1.969-.792.407-1.675.61-2.693.61-.995 0-1.9-.203-2.692-.633-.792-.407-1.426-1.063-1.878-1.968-.476-.883-.702-2.06-.702-3.53 0-1.47.226-2.648.702-3.553.452-.905 1.086-1.56 1.878-1.99.792-.43 1.697-.634 2.692-.634zm0 .453c-.792 0-1.425.453-1.923 1.335-.498.905-.747 2.376-.747 4.39s.25 3.484.747 4.367c.498.882 1.131 1.312 1.923 1.312.77 0 1.403-.452 1.924-1.335.497-.86.746-2.33.746-4.344 0-2.014-.249-3.485-.77-4.39-.497-.882-1.13-1.335-1.9-1.335zM70.726 21.943V37.58c0 .633.113 1.063.362 1.29.248.226.678.339 1.267.339v.475a27.96 27.96 0 00-1.2-.068c-.543-.022-1.086-.022-1.629-.022-.543 0-1.086 0-1.651.022-.544.023-.95.045-1.222.068v-.475c.588 0 .995-.113 1.244-.34.249-.226.385-.656.385-1.29v-12.92c0-.678-.113-1.176-.34-1.515-.226-.317-.656-.476-1.29-.476v-.475a14.914 14.914 0 002.829 0c.453-.068.86-.136 1.245-.249zM82.808 27.894l-6.245 11.45h2.036c.611 0 1.132-.113 1.607-.362.475-.25.86-.634 1.154-1.2.294-.565.475-1.29.543-2.217h.52c0 1.018 0 1.855.023 2.534.023.679.045 1.245.068 1.675-.679-.023-1.38-.046-2.104-.068-.724-.023-1.449-.023-2.15-.023-.77 0-1.561 0-2.353.023-.792.022-1.539.068-2.263.09l6.245-11.45h-2.082c-.656 0-1.199.137-1.674.385-.475.25-.837.634-1.109 1.177-.249.566-.43 1.29-.497 2.218h-.498c0-1.019 0-1.878-.023-2.535a112.54 112.54 0 00-.068-1.674c.656.023 1.358.045 2.082.068.724.022 1.448.022 2.172.022.747 0 1.516-.022 2.308-.045.792-.022 1.561-.045 2.308-.068zM94.778 21.943v15.274c0 .679.113 1.176.34 1.493.248.34.678.498 1.29.498v.475a14.556 14.556 0 00-1.404-.068c-.52 0-.995.023-1.448.068-.43.045-.837.136-1.222.249V24.659c0-.68-.113-1.177-.362-1.516-.226-.317-.656-.476-1.267-.476v-.475a14.914 14.914 0 002.828 0c.453-.068.86-.136 1.245-.249zm-5.091 5.748c.656 0 1.267.135 1.81.43.566.294.95.769 1.177 1.448l-.272.249c-.204-.543-.52-.928-.928-1.177a2.583 2.583 0 00-1.38-.385c-.86 0-1.561.453-2.104 1.38-.543.906-.815 2.309-.792 4.21 0 1.244.113 2.285.317 3.077.203.792.52 1.357.927 1.742.43.385.928.566 1.516.566.589 0 1.11-.25 1.584-.747.475-.498.77-1.222.86-2.15l.204.475c-.159 1.019-.52 1.81-1.086 2.376-.566.543-1.335.815-2.308.815-.928 0-1.743-.226-2.444-.656-.702-.453-1.222-1.132-1.607-2.037-.384-.927-.565-2.081-.565-3.462 0-1.38.226-2.511.679-3.416.475-.928 1.086-1.607 1.855-2.06a4.97 4.97 0 012.557-.678zM103.127 27.69c1.018 0 1.9.204 2.693.634.792.43 1.403 1.086 1.878 1.991.475.905.701 2.082.701 3.553 0 1.47-.226 2.647-.701 3.552-.475.883-1.086 1.539-1.878 1.969-.792.407-1.675.61-2.693.61-.995 0-1.9-.203-2.692-.633-.792-.407-1.426-1.063-1.878-1.968-.476-.883-.702-2.06-.702-3.53 0-1.47.226-2.648.702-3.553.452-.905 1.086-1.56 1.878-1.99.792-.43 1.697-.634 2.692-.634zm0 .453c-.792 0-1.425.453-1.923 1.335-.498.905-.747 2.376-.747 4.39s.25 3.484.747 4.367c.498.882 1.131 1.312 1.923 1.312.77 0 1.403-.452 1.924-1.335.497-.86.746-2.33.746-4.344 0-2.014-.249-3.485-.77-4.39-.497-.882-1.13-1.335-1.9-1.335zM117.292 27.69c.43 0 .815.091 1.11.272.316.181.542.407.7.702.159.271.25.588.25.927 0 .43-.136.815-.408 1.11-.249.316-.61.474-1.04.474-.385 0-.702-.113-.974-.34-.249-.225-.384-.542-.384-.927 0-.34.09-.61.249-.837a2.05 2.05 0 01.61-.566.773.773 0 00-.543-.158c-.543.022-1.018.249-1.448.679-.407.407-.724.905-.973 1.493-.249.588-.362 1.131-.362 1.63v5.203c0 .747.204 1.222.611 1.471.408.25.973.385 1.697.385v.475c-.34-.023-.837-.045-1.493-.068-.634-.022-1.312-.022-2.014-.022-.543 0-1.086 0-1.63.022-.542.023-.95.045-1.244.068v-.475c.589 0 .996-.113 1.245-.34.249-.226.385-.656.385-1.29v-7.104c0-.679-.114-1.177-.34-1.516-.226-.317-.656-.475-1.29-.475v-.476c.476.046.95.068 1.403.068.52 0 .996-.022 1.426-.09.452-.045.86-.113 1.244-.226v2.602c.181-.43.43-.86.724-1.267a3.886 3.886 0 011.086-1.019c.43-.249.883-.384 1.403-.384zM125.868 21.989c.453 0 .86.067 1.2.18.339.114.656.272.927.476.204.18.385.407.52.656.136.249.204.543.204.837 0 .385-.136.702-.385.95a1.296 1.296 0 01-.95.385c-.385 0-.724-.113-.995-.362-.272-.249-.408-.566-.408-.995 0-.34.09-.634.272-.86a1.56 1.56 0 01.792-.475.582.582 0 00-.317-.295c-.158-.09-.385-.135-.679-.135-.34 0-.61.067-.86.203a1.56 1.56 0 00-.543.543c-.158.294-.271.702-.34 1.267-.044.566-.067 1.449-.067 2.603v1.063h2.421v.453h-2.421v8.87c0 .746.204 1.221.61 1.47.43.25.996.385 1.698.385v.475a59.74 59.74 0 00-1.539-.068c-.656-.022-1.335-.022-2.081-.022a31.493 31.493 0 00-2.76.09l-.001-.475c.588 0 .996-.113 1.245-.34.248-.226.384-.656.384-1.29v-9.095h-1.72v-.453h1.72c0-1.335.09-2.376.272-3.077.203-.702.52-1.313.973-1.833.316-.34.724-.611 1.199-.815a4.266 4.266 0 011.63-.316z"
        fill-rule="nonzero"
      ></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 40 32"
      id="icon-menu"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.578 3.158H38.42a1.58 1.58 0 000-3.158H1.578a1.58 1.58 0 000 3.158zM1.578 17.309H38.42a1.58 1.58 0 000-3.158H1.578a1.58 1.58 0 000 3.158zM1.578 31.156H38.42a1.58 1.58 0 000-3.158H1.578a1.58 1.58 0 000 3.158z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 40 37"
      id="icon-mute"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.249 3.961a1.848 1.848 0 00-3.036-1.414L9.625 12.28c-.418.351-.659.869-.659 1.415v9.094c0 .546.241 1.063.66 1.414l11.587 9.734a1.846 1.846 0 003.036-1.414V3.96zM6.476 13.479a.647.647 0 00-.647-.647H.653a.647.647 0 00-.647.647v9.537c0 .357.29.647.647.647h5.176c.357 0 .647-.29.647-.647V13.48zM36.488 6.607c-.22-.487-.704-.8-1.238-.8-.256-.003-.54-.003-.81-.003a.733.733 0 00-.671 1.032c1.038 2.316 3.415 7.982 3.415 11.225 0 3.371-2.57 9.607-3.53 11.82a.574.574 0 00.526.802l1.016.001c.568 0 1.08-.337 1.306-.858.975-2.256 3.502-8.398 3.502-11.742 0-3.356-2.546-9.324-3.516-11.477zM30.397 10.169a1.355 1.355 0 00-1.233-.794c-.156-.005-.32-.005-.484-.005a.733.733 0 00-.67 1.032c.822 1.799 2.39 5.529 2.39 7.715 0 2.298-1.731 6.458-2.506 8.204a.573.573 0 00.525.803c.225.003.465.003.691.003.565 0 1.078-.335 1.304-.854.78-1.773 2.478-5.864 2.478-8.139 0-2.286-1.715-6.27-2.495-7.965z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 40 35"
      id="icon-unmute"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M33.093 15.923L27.769 10.6a.295.295 0 00-.419 0l-1.078 1.079a.295.295 0 000 .419l5.322 5.322-5.322 5.324a.295.295 0 000 .419l1.078 1.078a.295.295 0 00.42 0l5.323-5.322 5.322 5.322a.295.295 0 00.42 0l1.078-1.078a.295.295 0 000-.42L34.59 17.42l5.323-5.322a.295.295 0 000-.42L38.834 10.6a.295.295 0 00-.419 0l-5.322 5.323zM23.15 3.968a1.848 1.848 0 00-3.037-1.415L9.216 11.706c-.417.352-.659.87-.659 1.415v8.605c0 .546.242 1.063.66 1.415l10.896 9.154a1.847 1.847 0 003.036-1.415V3.968zM6.185 12.87a.618.618 0 00-.618-.618H.625a.618.618 0 00-.618.618v9.106c0 .341.277.618.618.618h4.942c.34 0 .618-.277.618-.618V12.87z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 30 40"
      id="icon-next"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.984 18.286L-.001 0v40l24.985-18.286v14.938c0 .259.208.47.469.47h3.749a.47.47 0 00.47-.47V3.348a.47.47 0 00-.47-.47h-3.749c-.26 0-.47.211-.47.47v14.938z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 25 37"
      id="icon-pause"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h9.014v36.298H0zM15.54 0h9.014v36.298H15.54z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 28 40"
      id="icon-play"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27.327 20L0 40V0l27.327 20z"></path>
    </symbol>
    <symbol
      fill-rule="evenodd"
      clip-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      viewBox="0 0 30 40"
      id="icon-prev"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.687 18.286L29.67 0v40L4.687 21.714v14.938c0 .259-.209.47-.47.47H.47a.47.47 0 01-.47-.47V3.348a.47.47 0 01.47-.47h3.748c.261 0 .47.211.47.47v14.938z"></path>
    </symbol>
    <symbol
      id="mapmap"
      viewBox="0 0 685.7 959.634"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="ast0"
        d="M201.5 114.734l6.1 116.2-8.9.4 2.7 60.4c2.8 63.5-17.1 125.9-55.6 175l-10 15.1-4.6 5.8c-9 11.5-39 31.3-70.8 46.5-31.8 15.1-65.6 42.8-42.3 69.9 29.3 34 216.3 287.3 216.3 287.3l-54 14.3 139.8 54 175.1-516.1c31.8-92.9 27.4-192.4-9.1-279.9 0 0-21.6-57.3-84.5-126.5l-5.1-5.1c-38.4-38.6-100.5-39.4-139.9-2l-58 55.7 2.3 17.8"
        fill="#dfdfdf"
      />
      <path
        class="ast0"
        d="M685.7 466.534l-6-3c-9.4-3-19.7-2.1-28.3 2.6l-91.7 49.6c-2.2 1.2-4.5 2.1-6.9 2.7l-32.9 8.3c-3.4.9-7 1.2-10.5.9l-19.3-1.5 27.3-78.6c32.7-94.2 28.1-195.1-9.3-283.9h28.4c14 0 27.2 6.7 35.5 18l113.5 155.1zM84.1 177.034l60.8-54.1 29.1-1.5 1.6 51.5zM175.6 186.734l-107.2 5.6-68.4 61.3v292.6s86.3-34.7 118-69.5c31.7-34.8 51.1-73 56.2-105.2 5.1-32.2 1.4-184.8 1.4-184.8z"
        fill="#dfdfdf"
      />
      <g transform="translate(-107.3 -124.166)">
        <path
          class="ast1"
          d="M341.4 1015.1l-2.8-3.8-22.9-30.9-180.9-240.7-14.2-18.5-2.5-16.7 6.7-14.4 23.3-22.9s8.1-3 22-10.2c13.9-7.2 46.8-26.9 46.8-26.9l21.6-18.4 101.4 219.1 20.6 42s10.4 23.7 16.7 43c6.3 19.3 19 56.1 19 60.3 0 4.2 3.1 19.6-24.2 29-27.3 9.4-30.4 10.4-30.4 10.4z"
          fill="#fff"
        />
        <circle
          class="ast2"
          cx="521.7"
          cy="683.4"
          r="7.4"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast1"
          d="M495.9 690.1l-27.5 1.4c-.7 0-1.4.3-2 .8l-8.3 7.6c-.8.7-1.9 1-2.9.7l-6.1-1.6c-.3-.1-.5-.1-.8-.1h-11.5c-.8 0-1.6.3-2.2.9-.8.8-1.9 1-3 .8l-6.1-1.6c-.3-.1-.5-.1-.8-.1h-7.5c-.4 0-.7.1-1 .2l-4.6 1.7c-.5.2-1 .2-1.5.2l-13.1-1.9c-.5-.1-1 0-1.5.1l-12 4.2c-.6.2-1.2.6-1.5 1.2l-5.5 8c-.4.5-.5 1.1-.5 1.8v18.2c0 .5.1 1.1.4 1.5l11.3 19.8c.4.6.9 1.1 1.5 1.3l5.9 2.4c.7.3 1.3.9 1.6 1.6l38.2 82.5c.1.1.1.3.2.4l1.5 5c.5 1.8 2.6 2.7 4.3 1.9l8.7-4c1.9-.8 4 .3 4.4 2.3l2.8 15.8c0 .1 0 .2.1.3l2.5 8.9c.5 1.9 2.7 2.8 4.5 1.9l9.6-5.2c.8-.4 1.4-1.2 1.6-2l4.4-19.3c.3-1.1 1-2 2.1-2.3l6.7-2.1c.9-.3 1.6-.9 1.9-1.8l15.9-37.6c.1-.2.2-.5.2-.7l6-35.1c0-.3.1-.5.2-.7l8.5-19.5c.4-1 .3-2.1-.2-2.9l-7.3-11.3c-.2-.2-.3-.5-.5-.6l-8.8-7.9c-1.2-1-1.4-2.8-.5-4.1l10.9-15.6c.7-1.1.7-2.5 0-3.6l-7.3-10.5c-.6-.8-1.5-1.3-2.6-1.3h-8.8zM428.1 332.2l51.9 3.3-3.9 11.9-48.9-4zM420.376 278.958l.295-3.487 118.67 10.03-.294 3.487zM431.904 290.57l.377-4.685 65.789 5.293-.377 4.685zM582.9 391.2l9.3.9-.2 4.2c-.3 0-.5-.1-.8-.1-2.6 0-4.8 2.1-4.8 4.8 0 2.7 2.1 4.8 4.8 4.8h.3l-.3 5.1-10.2-.5-.6 8 15.2 1s5.7-.5 10.5-4.6c3-2.6 5.7-6.7 6.4-13 1.8-16.3-16.4-19.6-16.4-19.6l-12.7-.9-.5 9.9M426.7 284.4l-6.2-.8-2.2 31-3.2-.3s-.9 2.4-2.5 3.1c-1.6.7-2.3 1.5-2.4 2.5-.1 1-.4 8.4-.4 8.4l13.9 1.3zM540.69 301.586l.489-6.08 30.8 2.477-.488 6.08z"
          fill="#fff"
        />
        <path
          class="ast3"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10.002"
          stroke-width="3.00109003"
          d="M538.537 356.615l4.694-56.508 30.397 2.525-4.694 56.508z"
        />
        <path
          class="ast1"
          fill="#fff"
          d="M547.8 252l-60.6-5.3-1.4 14-11.9-1 .9-14.2-49.1-4.7 1.8-31.1L549.8 221zM347.4 199.1l53.9 2.7s2.1 27.2-29.1 26.2c-28.8-.9-24.8-28.9-24.8-28.9z"
        />
        <path
          class="ast4"
          fill="#d7dbe7"
          d="M530.012 400.536l.606-8.68 19.253 1.344-.605 8.68zM366.5 564.7l9.7-6 12.2 18.8-10.1 6.1 5.1 7.9-64 38.6-20.7-36.9 63-36.8zM351.9 392.9l.1 7.2 49.3 2.7.3-24.9-12.9-1.2-.1-2.3-45.2 5.4.9 12.6zM575.854 394.71l.348-4.987 4.988.348-.348 4.988zM575.049 408.192l.348-4.988 4.988.348-.348 4.988z"
        />
      </g>
      <g transform="translate(-107.3 -124.166)">
        <path
          class="ast5"
          d="M327.6 1020.2s17-5.7 44.4-15.1c27.4-9.4 25.6-24.1 24.2-29 0 0-9.8-33.4-13.3-43.8"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast6"
          d="M239.1 611.1l101.4 219.1 20.6 42s16.3 40.4 22.5 59.8"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
        <path
          class="ast7"
          d="M237.8 611.7l101.3 219.1 20.6 42s16.3 40.4 22.5 59.8"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
        <path
          class="ast1"
          d="M471.8 380.6l7.4-.9 12.3.9-4.3 11.2-9.7-.2c-.1.1 1.8-3.7-5.7-11zM470.3 401l1.5 2.5 11 1.7 5.3-3.5-1.7-8.4-9-.9s.7 2-2.5 4.7-4.6 3.9-4.6 3.9z"
          fill="#fff"
        />
        <path
          class="ast1"
          d="M553.7 378.7l-.4 7.1-17.5-1.3-.3 3.5-23.7-2-.3 3.5-22.8-1.1s.5-8.1 8.3-11.4c7.7-3.3 9.6-2.2 12.8-2 3 .3 43.9 3.7 43.9 3.7zM488.6 398.3l22 1.6-.3 3.8 23 1.9-.3 3.6 19.5 1.1-.4 5.8-48.6-3.7c.1-.1-13.6-1.8-14.9-14.1z"
          fill="#fff"
        />
        <path
          class="ast8"
          d="M411 550.8l1 .1c12.9 1.8 26-.7 37.3-7.2l5.6-3.2c1.8-1 3.7-1.8 5.7-2.2l18.7-3.7c2.3-.5 4.6-.5 6.9-.1l4.7.8c2.1.3 4.4 0 6.3-.9l6.7-3.2c1.5-.7 2.9-1.7 4.1-3l5.2-5.5c2.7-2.8 4.7-6.3 5.8-10l.7-2.2c.9-3.1 2.3-6 4.2-8.7l8.1-12c2.9-4.3 8.5-6 13.3-4l.5.2c2.3 1 5 .1 6.5-2l6.5-7.2c.5-.5 1-1 1.6-1.4 11.9-7.4 56.1-41.1 56.1-41.1"
          fill="none"
          stroke="#d7dbe7"
          stroke-miterlimit="10"
        />
        <path
          class="ast9"
          d="M503.2 617.9c.6.6 1.5.5 2.3 1-.1 6.7-3.6 11.4 7.4 36.3 3.7 10.5 5.9 16.9 7.2 20.9M447 526.1c28.6 41.4 33.5 47.2 61.9 64.4l-.8 8.6s-7.4 2.6-7.7 8.8c0 0-1.1 5.9 2.8 10"
          fill="none"
          stroke="#a4a4a4"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast6"
          d="M422 429.7c.7 25.2 4.3 66.6 23.8 94.8.4.6.8 1.1 1.1 1.7M431.9 281.9l-10.4 125.7s.1 8.7.5 21.8"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
        <path
          class="ast7"
          d="M430.9 281.9l-10.4 125.7s-.1 10.6.3 23.8v.2c.7 25.2 4.5 65.5 24 93.7.4.6.8 1.1 1.1 1.7"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
        <path
          class="ast5"
          d="M509.1 590.7s10.3 4.5 8 20.3"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast6"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M307.5 413.2l39.7-.6 6.9-8.5 57.2 3.1L414 387l43.2 3"
        />
        <path
          class="ast7"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M312.6 412.4l33.9-.8 6.6-8.5 57.2 2.6 2.7-20 44.2 3.3"
        />
        <path
          class="ast5"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
          d="M503.4 287.8l-5.8 69.6M570.7 364.5l17 1.3"
        />
        <path
          class="ast7"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M426.6 352.6l146 11.3"
        />
        <path
          class="ast6"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M426.5 354L573 365.4"
        />
        <path
          class="ast5"
          d="M475.4 340.7c6.7.5 12.4 6.2 12.8 13l-.2 2.9"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast6"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M427.5 338.6l46.5 3.3"
        />
        <path
          class="ast7"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M427.6 337.6l46.4 3.3"
        />
        <path
          class="ast10"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2.939"
          d="M479.2 391.7l7.3.6"
        />
        <circle
          class="ast11"
          cx="467.5"
          cy="390.6"
          r="1.8"
          stroke="#a4a4a4"
          stroke-miterlimit="10"
        />
        <path
          class="ast5"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
          d="M558.9 292.5l-1.7 21M576 321.3l-12.4-1M550.1 318.5l-8.1-.6M541 335.5l29.2 2.3M556.4 326.1l-1 10.5M554.9 347.4l-.9 10.2M515.7 661s2.5 0 4.1.6c1.6.6 7 4.7 11.7 1.2 4.7-3.5 26.5-40.3 26.5-40.3s.7-2.2.7-2.8M340.9 518.9v16c0 8.9 11.8 7.3 16.2 7.2 11.5-.2 14.8-.4 14.8-.4 1.6.2 2.6 1.8 2.2 3.3l-2.1 6M346.2 412.6s-21.7 18.3-22.1 18.8l-9.2 51.9-2.3 10.8s-4.7 30.6 6.6 35.2c2.4 1 3.6 1.7 7.2 3.3M296 594.2s-15.4 11.3-52.9 11.7"
        />
        <path
          class="ast6"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M421.8 431.5L376.4 479l-32.7 37.8-16.6 16.9-14.6 21-16.5 39.5"
        />
        <path
          class="ast12"
          fill="none"
          stroke="#a4a4a4"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M421.6 430l-1.7 1.8"
        />
        <path
          class="ast13"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="4.9952,4.9952,4.9952,4.9952"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M416.5 435.4L404.3 448"
        />
        <path
          class="ast14"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="4.9952,4.9952,4.9952,4.9952,4.9952,4.9952"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M402.6 449.8L375.4 478l-32.7 37.8-16.6 16.9-14.7 21-14.8 35.9"
        />
        <path
          class="ast12"
          fill="none"
          stroke="#a4a4a4"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M295.6 591.9l-.9 2.3"
        />
        <circle
          class="ast2"
          cx="303.1"
          cy="672.3"
          r="5.1"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast5"
          d="M338.5 662.9s-6.6 13.8-6.4 25.7c.1 11.9 1.2 127.9 1.2 127.9M308.2 672.3s18.4 2.1 25.9 1.3M517.2 690.1s-6.4 6.7-15.5 13.6c-9.2 6.9-15.3 14.2-15.3 14.2l-8.6 6.1s-18.2 16.1-19.5 34.4c-1.3 18.3 0 44.5 0 44.5l1.2 24.1-1.8 21.7s.4 10.2 7.1 21.7c6.7 11.4-1.1 37.2-4.1 49.5-3 12.3-17.2 39.7-17.2 39.7l-20.6 31s-17.8 25.1-17.7 60.3"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast5"
          d="M441.8 962.3l-21.5-12.8s-14.3-10.7-28.7-2.7c-.9.4-1.6.8-2.4 1.2"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast10"
          d="M570.5 417.5l-66.4-5.5c-10.3-.9-17.9-9.9-17-20.1v0c.9-10.3 9.9-17.9 20.1-17l65.9 5.5M606.2 414.9c-3.7 3.2-8.5 4.9-13.8 4.5l-21.9-1.8"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2.939"
        />
        <path
          class="ast15"
          d="M573.1 380.9l21.7 1.8c10 .8 17.3 9.7 16.5 19.7v0c-.4 5-3.2 9.9-6.7 12.9"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="4.8769,4.8769,4.8769,4.8769,4.8769,4.8769"
          stroke-miterlimit="10"
          stroke-width="1.463"
        />
        <path
          class="ast10"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2.939"
          d="M573.2 380.7l7.2-86.5-162.1-13.4v-20.1"
        />
        <path
          class="ast7"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M572.7 395.3l1.5-17.9"
        />
        <path
          class="ast12"
          fill="none"
          stroke="#a4a4a4"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M571.5 395.3l1.4-18.1"
        />
        <path
          class="ast10"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2.939"
          d="M570.2 417.4l1.6-18.8"
        />
        <path
          class="ast5"
          d="M446.5 526.7l-25.1 14.6c-9.5 5.5-16.3 14.6-19 25.2l-.7 2.8c-1.9 7.5-17.4 25.8-17.4 25.8l-65.6 39.8"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast7"
          d="M609 421.3l-17.7 17.3c-5.7 5.6-12.1 10.4-19 14.5l-126.6 73.4"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
        <path
          class="ast6"
          d="M609.7 422.6L592 439.9c-5.7 5.6-12.1 10.4-19 14.5l-126.6 73.4"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
        <path
          class="ast5"
          d="M409.5 672.7s-1 18.5-2 22.5-1.7 8.9-.6 14.8 2.6 19.1 4.1 21.3c1.5 2.3 8 8.8 10.8 8.3 2.8-.5 13.1-4.8 18.6-6.5 5.5-1.7 9.3-2.5 9.3-2.5s6.9-2.5 11.5 3.3c4.1 5.2 3.7 4.9 3.7 4.9"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast16"
          d="M515 663l-11.4 6.2s-6.1 2.2-3.9 7.8c2.1 5.7 3.9 5.7-.5 15.2.1-.1 5.9 8.8 5.9 8.8M498.7 691.5l-7.9 4.3s-4.6 2.3-11 1.8c-6.5-.6-9.1.1-13 3.4-3.9 3.3-7.1 4.3-11.4 5.1-4.3.8-10 1.9-10.5-1.2-.5-3.1-.9-2.8-1.7-2.8-.8 0-2.3-.5-1.8 2.9.5 3.4-2 2-2 2s-2.5-1.3-2.5 2.2-2 2.7-3.9 3c-2 .3-7.6.6-7.6.6s-3.2-.5-2-4.9c0 0 3-4.5-1-5s-4 3.2-4 3.2-.1 3.2-4 1.2-3.8-2.3-7.2-1.8c-3.4.5-8 2.3-11.5 2.3-3.5.1-10-2.9-11 3.6-1.1 6.5-1.5 12.2-1.5 12.2s1 5.3 2.6 8.1-.5 10.7 6.3 10c6.8-.7 17.5-1.6 17.5-1.6s5.1-.5 7.1-3.4M401.5 741.9l-1.6 5.3s-1 1.7 1.6 7.4 9.8 22.2 9.8 22.2 2 9.5 11 21.4c9 11.9 13.6 30 16.3 36.4 2.7 6.4 8.1 21.7 8.1 21.7s.8 25.6 20.6 31.7M509 698.9s.7 9.2 10.5 11.1M527.1 714.7s2.1 1-.8 6.1c-2.9 5.1-8.3 14.1-8.5 14.7-.2.6-.9 6-4.3 12s-8 18.8-8.5 20.6c-.5 1.8-.8 6.9-1.7 13.7-.9 6.8-12.6 40-12.6 40s-1.6 14.3-9.6 15.7c-8.1 1.3-8.4 4.7-10.8 10.7-2.5 6-2.8 8.3-3 10.3-.3 2-6.8 2.3-6.8 2.3M478.1 837.3s-8.6-13.6-6.5-21"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast16"
          d="M429.4 808.1s1.7-1.3 3 1.1c1.4 2.3 2.4 2.3 3.7 1.6 1.4-.8.1-4.2.8-5.3.7-1.1 3.9-1.9 3.9-1.9M511 752.8s-23.5 2.6-24.1 2.6c-.6 0-3.5-1.3-7.4 2.9-3.9 4.2-20.4 3.8-20.4 3.8l-10.4 1.2M427.9 738.5s2.1 12.5 2.4 13.1c.2.6 3 3.7 3.3 8.5.2 4.8.5 11 .5 11s-.7 2.3 0 4.3 3.3 7.7 3.3 7.7.5 3.6 6.4 2.3c5.9-1.3 13.2-3.6 13.2-3.6M429.7 752.8s-3.9 4.1-5.5.4c-1.6-3.7-1.9-2.3-3-1.2-1.1 1.1-3.9 1.8-5.4.8M489.7 716s3.2 9.8 4.5 11.9c1.3 2.2 6.5 13.5 6.8 15 .3 1.5 1.3 7.7 1.1 9.9M429.7 713.4v6.2c0 1.8 0 4.8 3 5.8s4.6 6.8 5 8"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast16"
          d="M433.7 757.5s5.2-1 5.2-2.2c0-1.2-1-2 1.9-3.3 3-1.3 1.8-5.8 5.5-5.7 3.7.1 3.7 2 3.6 6.4-.1 4.4-1.6 9.5-1.8 14.1-.2 4.6-1 5.4 1.4 9.8s3.8 5.7 3.8 5.7"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast10"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2.939"
          d="M424 281.9l-3.1 46.2-13-1-3.2 52.7M407 355.2l18 1.4"
        />
        <circle
          class="ast2"
          cx="650.9"
          cy="635.3"
          r="5.9"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <circle
          class="ast2"
          cx="467.5"
          cy="390.6"
          r="9.9"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast5"
          d="M593.9 388.1c7.1.8 12.3 7.1 11.5 14.2-.8 7.1-7.1 12.3-14.2 11.5"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <circle
          class="ast5"
          cx="557.2"
          cy="319.5"
          r="6"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast5"
          d="M560.9 337.5c-.3 3-3.1 5.1-6.1 4.8-3-.3-5.2-3-4.8-6M355.6 537.7l1.8-3.7h5.1l2.1 3.7"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <circle
          class="ast2"
          cx="511.8"
          cy="609.5"
          r="5.5"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast5"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
          d="M530.5 708.5l-4 6.2-7.2-4.9 3.8-6.1zM572.3 399.5l17.6 1.3"
        />
        <circle class="ast1" cx="480.3" cy="342.4" r="4.2" fill="#fff" />
        <path
          class="ast16"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="3"
          d="M635.6 322.6l27.5 35 25.9-18.3 97 127.2-55.7 46.1 18.1 21.9 24.9 30.2-17.5 16-25.5-31.5 18.1-14.7"
        />
        <circle
          class="ast2"
          cx="651.5"
          cy="371.2"
          r="7.5"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast16"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="3"
          d="M656.5 377.5l91.3 119.3M721.7 382.3l-74.3 57.3 67.1 93.4M757.2 428.8L659.9 504M638.3 525.4l41.5 53.7M733.8 518.3l-114.2 88M626.3 602.2l20.5 27.3M604.7 646.8l34.6-25.8"
        />
        <path
          class="ast9"
          d="M509.1 647.2c41.9-14.5 53.6-30.9 65.2-55.7 10.7-22.9 19.9-41.2 34-97.7 14.1-56.5 6.4-68.4 6.4-68.4l-7.5-10.2"
          fill="none"
          stroke="#a4a4a4"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast5"
          d="M296 594.2l22.4 40.7c.2.2 1.5 3.3 16.6 23.3 13.4 17.7 26.9 19 44.6 17.3 17.7-1.6 48.9-7 48.9-7s38.7-6.8 80.6-21.3"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast6"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M302.4 485.2l71-3.2"
        />
        <path
          class="ast7"
          fill="none"
          stroke="#a4a4a4"
          stroke-dasharray="5,5,5,5,5,5"
          stroke-miterlimit="10"
          stroke-width="1.5"
          d="M302.7 483.9l72-3.1"
        />
        <circle
          class="ast2"
          cx="480.3"
          cy="342.4"
          r="5.3"
          fill="#fff"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="3"
        />
        <path
          class="ast6"
          d="M573.3 379.6l21.3 1.7c11.1.6 18.8 10.9 18 21v0c-.4 5-2.2 9.3-5.8 12.9"
          fill="none"
          stroke="#a4a4a4"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
      </g>
      <g>
        <path
          class="ast17"
          d="M215.7 70.834l41-40.8c39.4-37.5 101.6-36.6 139.9 2l5.1 5.1c22.3 22.4 41.5 47 57.4 73.3l-1.7 36.1"
          fill="none"
          stroke="#374a86"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="5"
        />
        <path
          class="ast18"
          d="M234.4 891.334s-187-253.4-216.3-287.3c-23.3-27.1 10.4-54.8 42.3-69.9 31.9-15.1 61.8-34.9 70.8-46.5l4.6-5.8 10-15.2c38.5-49.1 58.4-111.5 55.6-175l-1.5-25.2"
          fill="none"
          stroke="#374a86"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="5"
        />
        <path
          class="ast17"
          d="M327.6 933.134l167.7-489.5c31.8-92.9 27.4-192.4-9.1-279.9"
          fill="none"
          stroke="#374a86"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="5"
        />
        <path
          class="ast19"
          d="M492.2 527.534l26.5-78.9c31.8-94.6 27.4-195.9-9.1-285"
          fill="none"
          stroke="#374a86"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="5.078"
        />
      </g>
      <g>
        <path
          class="ast20"
          fill="#374a86"
          d="M294.3 263.534l7.9-.1.2 12.8-8.4.1zM254.818 429.143l8.54-5.202 5.202 8.54-8.54 5.202zM279.6 902.234l1.4-17.7-9.9-.7-1.4 17.8zM309.6 805.934l-4.9-14.6-27.6 9 4.9 14zM172.3 163.834l-43.4 2.5.3 5.6-13.6.6-.7-18.4 36.4-1.7-1.3-26.6 20.3-.8zM119.902 191.814l32.893-.585.184 10.297-32.894.586zM160.098 220.133l11.486-.565 1.024 20.775-11.487.565zM155.076 672.277l21.855-7.48 7.48 21.855-21.855 7.48zM124.027 681.838l7.447-2.638 5.41 15.27-7.446 2.639zM145.585 708.648l24.785-8.492 4.635 13.528-24.786 8.491zM224.073 731.606l6.976-2.469 4.07 11.501-6.976 2.469zM218.3 775.634l36.5-12.9 6.5 19.4-69.9 24.9-.5-1.4-12.3 4.3-5.5-18 4.5-1.6-.5-1.4 7.5-2.7-1.2-4.2 33.3-11.8z"
        />
      </g>
      <g>
        <path
          class="ast20"
          d="M276.9 145.234l1.3-1.1 25.8 2.2 1.1 1.5-.2 3.5s.8.1 1.2.5c.5.4.7 1.1.7 1.1h.4l-.3 4.5h-.4s-.4.6-.8.9c-.7.4-1.4.3-1.4.3l-.2 3.5-1.1 1-1.6-.2-.8 9.3 3.5.3-.2 3.3 1.5.2s4.3 1.4 4.2 6.6c-.1 5.2-5.3 6.3-5.3 6.3l-1.6-.1-.7 8.5-3.9-.2-2.7 36h.4l-1.6 21.2-12.6-1.3v-1.9l-43.9 4.7 1 27.8-25.7-.7.6-14.5-16-.1-1.6-37.2 9-.4-2.2-52.4-1.7.1-.1-18.6 4.9-.1-1.9-36.5-4.1.1-.1-8.9 30.5-1.2 1.6 48 3.1-.4.3 20.1-3.4-.2 2.6 57.2 42.4-5 2.1-39.4-7.7-.8.8-8-2.1-1.8.4-4.1 2.4-1.4.6-5-2.2-1.7.4-1.9-3.1-.4.8-10.5 6.2.5z"
          fill="#374a86"
        />
      </g>
      <g>
        <path
          class="ast20"
          fill="#374a86"
          d="M213.2 70.634l15-1.9 1.5 32.6-13.1.8.2 4.1-11.2.6-.1-4.5-6.1.1-.7-16.7 15.1-.5zM272.3 46.734l15.5.5v-1.5l12 .3v-4.5l17.8.5-.3 12.4 5.8.3v7.2h-5.8l-.2 3.7H309l-.1 5-23.4-1.2v-1.6l-19.3-1.1v1.3l-24.4-1.2.4-17.1 5.6.1.2-6.3 24.3.6zM243.5 900.234l3.9 10.6 21.2-7.4-2-6.6-5 1.5-1.3-3.7 5.2-1.8-2.1-6.4-21.3 7.5 2.1 6z"
        />
      </g>
    </symbol>
  </svg>
);
export default SVGSymbols;
